import { initFancybox } from './lib-2sxc-fancybox';

const winAny = (window as any);
winAny.appContent = winAny.appContent || {};
winAny.appContent.initFancybox = initFancybox;

const searchInput = document.getElementById("app-video-library-search") as HTMLFormElement;
const videoElements = document.querySelectorAll('.video-item');
const filterToggle = document.querySelector('.app-video-library-filter-toggle');

if(filterToggle != null) {
  filterToggle.addEventListener('click', () => {
    document.querySelector('.app-video-library-tags').classList.toggle('hidden')
  })
}

const filterTags = document.querySelectorAll('.app-video-library-tag');
filterTags.forEach((item) => {
  item.addEventListener('click', () => {
    item.classList.toggle('active');

    filterByTags()
  })
});

function filterByTags() {
  const activeFilterTags = document.querySelectorAll('.app-video-library-tag.active');
  const filter = [];

  activeFilterTags.forEach((elem: HTMLElement) => {
    filter.push(elem.dataset.tag)
  })

  if(filter.length != 0) {
    hideVideoElements();

    showVideosByTagFilter(filter);
  } else {
    showVideoElements();
  }  
}

function showVideosByTagFilter(filter: any) {
  videoElements.forEach((item: HTMLElement) => {
    const tags = item.dataset.tags.split(',');
    if (filter.some((tag: any) => tags.includes(tag))) {
      item.classList.remove('video-hidden');
    }
  });
}


if(searchInput != null) {
  searchInput.addEventListener("keyup", (event) => {
    if (event.isComposing || event.keyCode === 229) {
      return;
    }
  
    const searchValue = searchInput.value.toLowerCase();
    const searchedElements = document.querySelectorAll(`[data-title*="${searchValue}"]`);
    const noResultElem = document.querySelector('.app-video-library-noresults') as HTMLElement;

    noResultElem.style.display = 'none';
  
    if(searchValue == "") {
      showVideoElements();
      return;
    }
  
    if(searchedElements.length == 0) {
      hideVideoElements();
      
      noResultElem.style.display = 'block';
      return;		
    }
  
    searchedElements.forEach((item) => {
      hideVideoElements();
      
      item.classList.remove('video-hidden');
    });
  });
}


function showVideoElements() {
  videoElements.forEach((item) => {
    item.classList.remove('video-hidden');
  });
}

function hideVideoElements() {
  videoElements.forEach((item) => {
    item.classList.add('video-hidden');
  });
}